import { useQuery } from "react-query";
import { Auth } from "shared/@auth/Auth";

export function useSingleContentsGet({ id }) {
  const { makeAuthedRequest } = Auth.useContainer();

  const { data, isLoading, refetch } = useQuery(
    ["contents", id],
    () =>
      makeAuthedRequest(`contents/${id}`, {
        method: "GET",
      }).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      }),
    {
      enabled: !!id,
    }
  );

  return {
    data,
    isLoading,
    refetch,
  };
}
